import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const queryStringParams: {} = process.env?.REACT_APP_DEPLOYMENT_VERSION
  ? { v: process.env?.REACT_APP_DEPLOYMENT_VERSION }
  : {};

const promise = i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpApi)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      loadPath: function (lngs: string[], namespaces: string[]) {
        const pathPrefix: string = window?.td_spa
          ? '/app/themes/exin/certification-wizard/current'
          : '';
        return pathPrefix + '/locales/{{lng}}/{{ns}}.json';
      },
      queryStringParams,
    },
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lng: window?.td_spa?.language,
  });

export default promise;
